import { Pipe, PipeTransform } from '@angular/core';
import { DropdownStepperChildren } from '@ui/shared/models';

@Pipe({ name: 'appIsValueSelectedInDropdownStepper' })
export class IsValueSelectedInDropdownStepperPipe<T> implements PipeTransform {
  transform(value: T, selectedChildren: DropdownStepperChildren<T>[]): boolean {
    return selectedChildren.some(child => child.value === value);
  }
}
